// ----------------------------------------------------------------------
// <copyright file="Izenda.MapCollectionConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
//

const WORLDS = {
  world: ['World', 'world']
};
import {nth, get, find, values, toLower} from 'lodash/fp';
const CONTINENTS = {
  africa: ['Africa', 'continents/africa'],
  antarctica: ['Antarctica', 'continents/antarctica'],
  asia: ['Asia', 'continents/asia'],
  'british-isles': ['British-Isles', 'continents/british-isles'],
  'usa-and-canada': ['Canada-and-United-States-of-America', 'continents/usa-and-canada'],
  'central-america': ['Central America', 'continents/central-america'],
  europe: ['Europe', 'continents/europe'],
  'middle-east': ['Middle East', 'continents/middle-east'],
  'nordic-countries': ['Nordic-Countries', 'continents/nordic-countries'],
  'north-america': ['North America', 'continents/north-america'],
  scandinavia: ['Scandinavia', 'continents/scandinavia'],
  'south-america': ['South America', 'continents/south-america']
};

const COUNTRIES = {
  af: ['Afghanistan', 'countries/af-all'],
  al: ['Albania', 'countries/al-all'],
  dz: ['Algeria', 'countries/dz-all'],
  as: ['American Samoa', 'countries/as-all'],
  ad: ['Andorra', 'countries/ad-all'],
  ao: ['Angola', 'countries/ao-all'],
  ag: ['Antigua and Barbuda', 'countries/ag-all'],
  ar: ['Argentina', 'countries/ar-all'],
  am: ['Armenia', 'countries/am-all'],
  au: ['Australia', 'countries/au-all'],
  at: ['Austria', 'countries/at-all'],
  az: ['Azerbaijan', 'countries/az-all'],
  bh: ['Bahrain', 'countries/bh-all'],
  bd: ['Bangladesh', 'countries/bd-all'],
  bb: ['Barbados', 'countries/bb-all'],
  by: ['Belarus', 'countries/by-all'],
  be: ['Belgium', 'countries/be-all'],
  bz: ['Belize', 'countries/bz-all'],
  bj: ['Benin', 'countries/bj-all'],
  bt: ['Bhutan', 'countries/bt-all'],
  bo: ['Bolivia', 'countries/bo-all'],
  ba: ['Bosnia and Herzegovina', 'countries/ba-all'],
  bw: ['Botswana', 'countries/bw-all'],
  br: ['Brazil', 'countries/br-all'],
  bn: ['Brunei', 'countries/bn-all'],
  bg: ['Bulgaria', 'countries/bg-all'],
  bf: ['Burkina Faso', 'countries/bf-all'],
  bi: ['Burundi', 'countries/bi-all'],
  kh: ['Cambodia', 'countries/kh-all'],
  cm: ['Cameroon', 'countries/cm-all'],
  ca: ['Canada', 'countries/ca-all', { STATE_LIST_NAME: 'CANADA_STATES', COUNTY_MAP: 'countries/ca-all-all' }],
  cv: ['Cape Verde', 'countries/cv-all'],
  cf: ['Central African Republic', 'countries/cf-all'],
  td: ['Chad', 'countries/td-all'],
  cl: ['Chile', 'countries/cl-all'],
  cn: ['China', 'countries/cn-all'],
  co: ['Colombia', 'countries/co-all'],
  km: ['Comoros', 'countries/km-all'],
  ck: ['Cook Islands', 'countries/ck-all'],
  cr: ['Costa Rica', 'countries/cr-all'],
  hr: ['Croatia', 'countries/hr-all'],
  cu: ['Cuba', 'countries/cu-all'],
  cy: ['Cyprus', 'countries/cy-all'],
  cz: ['Czech Republic', 'countries/cz-all'],
  cd: ['Democratic Republic of the Congo', 'countries/cd-all'],
  dk: ['Denmark', 'countries/dk-all'],
  dj: ['Djibouti', 'countries/dj-all'],
  dm: ['Dominica', 'countries/dm-all'],
  do: ['Dominican Republic', 'countries/do-all'],
  tl: ['East Timor', 'countries/tl-all'],
  ec: ['Ecuador', 'countries/ec-all'],
  eg: ['Egypt', 'countries/eg-all'],
  sv: ['El Salvador', 'countries/sv-all'],
  gq: ['Equatorial Guinea', 'countries/gq-all'],
  er: ['Eritrea', 'countries/er-all'],
  ee: ['Estonia', 'countries/ee-all'],
  et: ['Ethiopia', 'countries/et-all'],
  fo: ['Faroe Islands', 'countries/fo-all'],
  fj: ['Fiji', 'countries/fj-all'],
  fi: ['Finland', 'countries/fi-all'],
  fr: ['France', 'countries/fr-all'],
  ga: ['Gabon', 'countries/ga-all'],
  gm: ['Gambia', 'countries/gm-all'],
  ge: ['Georgia', 'countries/ge-all'],
  de: ['Germany', 'countries/de-all'],
  gh: ['Ghana', 'countries/gh-all'],
  gr: ['Greece', 'countries/gr-all'],
  gl: ['Greenland', 'countries/gl-all'],
  gd: ['Grenada', 'countries/gd-all'],
  gu: ['Guam', 'countries/gu-all'],
  gt: ['Guatemala', 'countries/gt-all'],
  gn: ['Guinea', 'countries/gn-all'],
  gw: ['Guinea Bissau', 'countries/gw-all'],
  gy: ['Guyana', 'countries/gy-all'],
  ht: ['Haiti', 'countries/ht-all'],
  hn: ['Honduras', 'countries/hn-all'],
  hu: ['Hungary', 'countries/hu-all'],
  is: ['Iceland', 'countries/is-all'],
  in: ['India', 'countries/in-all'],
  id: ['Indonesia', 'countries/id-all'],
  ir: ['Iran', 'countries/ir-all'],
  iq: ['Iraq', 'countries/iq-all'],
  ie: ['Ireland', 'countries/ie-all'],
  il: ['Israel', 'countries/il-all'],
  it: ['Italy', 'countries/it-all'],
  ci: ['Ivory Coast', 'countries/ci-all'],
  jm: ['Jamaica', 'countries/jm-all'],
  jp: ['Japan', 'countries/jp-all'],
  jo: ['Jordan', 'countries/jo-all'],
  kz: ['Kazakhstan', 'countries/kz-all'],
  ke: ['Kenya', 'countries/ke-all'],
  kv: ['Kosovo', 'countries/kv-all'],
  kw: ['Kuwait', 'countries/kw-all'],
  kg: ['Kyrgyzstan', 'countries/kg-all'],
  la: ['Laos', 'countries/la-all'],
  lv: ['Latvia', 'countries/lv-all'],
  lb: ['Lebanon', 'countries/lb-all'],
  ls: ['Lesotho', 'countries/ls-all'],
  lr: ['Liberia', 'countries/lr-all'],
  ly: ['Libya', 'countries/ly-all'],
  li: ['Liechtenstein', 'countries/li-all'],
  lt: ['Lithuania', 'countries/lt-all'],
  lu: ['Luxembourg', 'countries/lu-all'],
  mk: ['Macedonia', 'countries/mk-all'],
  mg: ['Madagascar', 'countries/mg-all'],
  mw: ['Malawi', 'countries/mw-all'],
  my: ['Malaysia', 'countries/my-all'],
  ml: ['Mali', 'countries/ml-all'],
  mt: ['Malta', 'countries/mt-all'],
  mr: ['Mauritania', 'countries/mr-all'],
  mu: ['Mauritius', 'countries/mu-all'],
  mx: ['Mexico', 'countries/mx-all'],
  md: ['Moldova', 'countries/md-all'],
  mc: ['Monaco', 'countries/mc-all'],
  mn: ['Mongolia', 'countries/mn-all'],
  me: ['Montenegro', 'countries/me-all'],
  ma: ['Morocco', 'countries/ma-all'],
  mz: ['Mozambique', 'countries/mz-all'],
  mm: ['Myanmar', 'countries/mm-all'],
  na: ['Namibia', 'countries/na-all'],
  nr: ['Nauru', 'countries/nr-all'],
  np: ['Nepal', 'countries/np-all'],
  nc: ['New Caledonia', 'countries/nc-all'],
  nz: ['New Zealand', 'countries/nz-all'],
  ni: ['Nicaragua', 'countries/ni-all'],
  ne: ['Niger', 'countries/ne-all'],
  ng: ['Nigeria', 'countries/ng-all'],
  kp: ['North Korea', 'countries/kp-all'],
  mp: ['Northern Mariana Islands', 'countries/mp-all'],
  no: ['Norway', 'countries/no-all'],
  om: ['Oman', 'countries/om-all'],
  pk: ['Pakistan', 'countries/pk-all'],
  pw: ['Palau', 'countries/pw-all'],
  pa: ['Panama', 'countries/pa-all'],
  pg: ['Papua New Guinea', 'countries/pg-all'],
  py: ['Paraguay', 'countries/py-all'],
  pe: ['Peru', 'countries/pe-all'],
  ph: ['Philippines', 'countries/ph-all'],
  pl: ['Poland', 'countries/pl-all'],
  pt: ['Portugal', 'countries/pt-all'],
  pr: ['Puerto Rico', 'countries/pr-all'],
  qa: ['Qatar', 'countries/qa-all'],
  rs: ['Republic of Serbia', 'countries/rs-all'],
  cg: ['Republic of the Congo', 'countries/cg-all'],
  ro: ['Romania', 'countries/ro-all'],
  ru: ['Russia', 'countries/ru-all'],
  rw: ['Rwanda', 'countries/rw-all'],
  kn: ['Saint Kitts and Nevis', 'countries/kn-all'],
  lc: ['Saint Lucia', 'countries/lc-all'],
  vc: ['Saint Vincent and the Grenadines', 'countries/vc-all'],
  ws: ['Samoa', 'countries/ws-all'],
  sm: ['San Marino', 'countries/sm-all'],
  st: ['Sao Tome and Principe', 'countries/st-all'],
  sa: ['Saudi Arabia', 'countries/sa-all'],
  sn: ['Senegal', 'countries/sn-all'],
  sc: ['Seychelles', 'countries/sc-all'],
  sl: ['Sierra Leone', 'countries/sl-all'],
  sg: ['Singapore', 'countries/sg-all'],
  sk: ['Slovakia', 'countries/sk-all'],
  si: ['Slovenia', 'countries/si-all'],
  sb: ['Solomon Islands', 'countries/sb-all'],
  so: ['Somalia', 'countries/so-all'],
  sx: ['Somaliland', 'countries/sx-all'],
  za: ['South Africa', 'countries/za-all'],
  kr: ['South Korea', 'countries/kr-all'],
  ss: ['South Sudan', 'countries/ss-all'],
  es: ['Spain', 'countries/es-all'],
  lk: ['Sri Lanka', 'countries/lk-all'],
  sd: ['Sudan', 'countries/sd-all'],
  sr: ['Suriname', 'countries/sr-all'],
  sz: ['Swaziland', 'countries/sz-all'],
  se: ['Sweden', 'countries/se-all'],
  ch: ['Switzerland', 'countries/ch-all'],
  sy: ['Syria', 'countries/sy-all'],
  tw: ['Taiwan', 'countries/tw-all'],
  tj: ['Tajikistan', 'countries/tj-all'],
  th: ['Thailand', 'countries/th-all'],
  bs: ['The Bahamas', 'countries/bs-all'],
  nl: ['The Netherlands', 'countries/nl-all'],
  tg: ['Togo', 'countries/tg-all'],
  tt: ['Trinidad and Tobago', 'countries/tt-all'],
  tn: ['Tunisia', 'countries/tn-all'],
  tr: ['Turkey', 'countries/tr-all'],
  tm: ['Turkmenistan', 'countries/tm-all'],
  ug: ['Uganda', 'countries/ug-all'],
  ua: ['Ukraine', 'countries/ua-all'],
  ae: ['United Arab Emirates', 'countries/ae-all'],
  gb: ['United Kingdom', 'countries/gb-all'],
  tz: ['United Republic of Tanzania', 'countries/tz-all'],
  vi: ['United States Virgin Islands', 'countries/vi-all'],
  us: [
    'United States of America',
    'countries/us-all',
    { STATE_LIST_NAME: 'US_STATES', COUNTY_MAP: 'countries/us-all-all' }
  ],
  'us-all-territories': [
    'United States of America with Territories',
    'countries/us-all-territories',
    { STATE_LIST_NAME: 'US_STATES', COUNTY_MAP: 'countries/us-all-all', BASE_NAME: 'United States of America' }
  ],
  uy: ['Uruguay', 'countries/uy-all'],
  uz: ['Uzbekistan', 'countries/uz-all'],
  vu: ['Vanuatu', 'countries/vu-all'],
  ve: ['Venezuela', 'countries/ve-all'],
  vn: ['Vietnam', 'countries/vn-all'],
  wf: ['Wallis and Futuna', 'countries/wf-all'],
  eh: ['Western Sahara', 'countries/eh-all'],
  ye: ['Yemen', 'countries/ye-all'],
  zm: ['Zambia', 'countries/zm-all'],
  zw: ['Zimbabwe', 'countries/zw-all']
};

const CANADA_STATES = {
  'ca-ab': ['Alberta', 'ca/ca-ab-all'],
  'ca-bc': ['British Columbia', 'ca/ca-bc-all'],
  'ca-mb': ['Manitoba', 'ca/ca-mb-all'],
  'ca-nb': ['New Brunswick', 'ca/ca-nb-all'],
  'ca-nl': ['Newfoundland and Labrador', 'ca/ca-nf-all'],
  'ca-nt': ['Northwest Territories', 'ca/ca-nt-all'],
  'ca-ns': ['Nova Scotia', 'ca/ca-ns-all'],
  'ca-nu': ['Nunavut', 'ca/ca-nu-all'],
  'ca-on': ['Ontario', 'ca/ca-on-all'],
  'ca-pe': ['Prince Edward Island', 'ca/ca-pe-all'],
  'ca-qc': ['Quebec', 'ca/ca-qc-all'],
  'ca-sk': ['Saskatchewan', 'ca/ca-sk-all'],
  'ca-yt': ['Yukon', 'ca/ca-yt-all']
};

const US_STATES = {
  'us-al': ['Alabama', 'us/us-al-all'],
  'us-ak': ['Alaska', 'us/us-ak-all'],
  'us-az': ['Arizona', 'us/us-az-all'],
  'us-ar': ['Arkansas', 'us/us-ar-all'],
  'us-ca': ['California', 'us/us-ca-all'],
  'us-co': ['Colorado', 'us/us-co-all'],
  'us-ct': ['Connecticut', 'us/us-ct-all'],
  'us-de': ['Delaware', 'us/us-de-all'],
  'us-dc': ['District of Columbia', 'us/us-dc-all'],
  'us-fl': ['Florida', 'us/us-fl-all'],
  'us-ga': ['Georgia', 'us/us-ga-all'],
  'us-hi': ['Hawaii', 'us/us-hi-all'],
  'us-id': ['Idaho', 'us/us-id-all'],
  'us-il': ['Illinois', 'us/us-il-all'],
  'us-in': ['Indiana', 'us/us-in-all'],
  'us-ia': ['Iowa', 'us/us-ia-all'],
  'us-ks': ['Kansas', 'us/us-ks-all'],
  'us-ky': ['Kentucky', 'us/us-ky-all'],
  'us-la': ['Louisiana', 'us/us-la-all'],
  'us-me': ['Maine', 'us/us-me-all'],
  'us-md': ['Maryland', 'us/us-md-all'],
  'us-ma': ['Massachusetts', 'us/us-ma-all'],
  'us-mi': ['Michigan', 'us/us-mi-all'],
  'us-mn': ['Minnesota', 'us/us-mn-all'],
  'us-ms': ['Mississippi', 'us/us-ms-all'],
  'us-mo': ['Missouri', 'us/us-mo-all'],
  'us-mt': ['Montana', 'us/us-mt-all'],
  'us-ne': ['Nebraska', 'us/us-ne-all'],
  'us-nv': ['Nevada', 'us/us-nv-all'],
  'us-nh': ['New Hampshire', 'us/us-nh-all'],
  'us-nj': ['New Jersey', 'us/us-nj-all'],
  'us-nm': ['New Mexico', 'us/us-nm-all'],
  'us-ny': ['New York', 'us/us-ny-all'],
  'us-nc': ['North Carolina', 'us/us-nc-all'],
  'us-nd': ['North Dakota', 'us/us-nd-all'],
  'us-oh': ['Ohio', 'us/us-oh-all'],
  'us-ok': ['Oklahoma', 'us/us-ok-all'],
  'us-or': ['Oregon', 'us/us-or-all'],
  'us-pa': ['Pennsylvania', 'us/us-pa-all'],
  'us-ri': ['Rhode Island', 'us/us-ri-all'],
  'us-sc': ['South Carolina', 'us/us-sc-all'],
  'us-sd': ['South Dakota', 'us/us-sd-all'],
  'us-tn': ['Tennessee', 'us/us-tn-all'],
  'us-tx': ['Texas', 'us/us-tx-all'],
  'us-ut': ['Utah', 'us/us-ut-all'],
  'us-vt': ['Vermont', 'us/us-vt-all'],
  'us-va': ['Virginia', 'us/us-va-all'],
  'us-wa': ['Washington', 'us/us-wa-all'],
  'us-wv': ['West Virginia', 'us/us-wv-all'],
  'us-wi': ['Wisconsin', 'us/us-wi-all'],
  'us-wy': ['Wyoming', 'us/us-wy-all']
};

/**
 * Get map information
 * @param  {string} key
 * @param  {array} mapList
 * @return {object}
 */
function getMapInfo(key, mapList) {
  const mapDetails = mapList ? mapList[key] : WORLDS[key] || CONTINENTS[key] || COUNTRIES[key] || [];
  return buildMapInfo(key, mapDetails);
}

/**
 * Build map information based on its definition,
 * key              value
 * first element    name
 * second element   file-path to get GEO file from server
 * third element    other information
 * @param  {string} key
 * @param  {array} mapDetails
 * @return {object}
 */
function buildMapInfo(key, mapDetails) {
  return {
    label: nth(0, mapDetails),
    value: key,
    geoFile: nth(1, mapDetails),
    others: nth(2, mapDetails)
  };
}

/**
 * build list of map
 * @param  {array} mapList
 * @return {array}
 */
function getList(mapList) {
  return Object.keys(mapList).map(key => getMapInfo(key, mapList));
}

/**
 * search map info by map level
 * @param  {string} mapLevel
 * @param  {object} geoPointProps
 * @return {object}
 */
function searchMapInfoByMapLevel(mapLevel, geoPointProps) {
  switch (mapLevel) {
    case 'CONTINENT':
      const continentName = get('properties.continent', geoPointProps) || get('continent', geoPointProps);
      return findMap(continentName, CONTINENTS);

    case 'COUNTRY':
      const countryId = get('id', geoPointProps) || get('hc-a2', geoPointProps);
      const countryKey = countryId.toLowerCase();
      return COUNTRIES[countryKey] && buildMapInfo(countryKey, COUNTRIES[countryKey]);

    case 'STATE':
      let stateKey = get('hc-key', geoPointProps) || get('hc-key', geoPointProps.properties);
      stateKey = toLower(stateKey);

      // only support states for Canada & US
      const map = CANADA_STATES[stateKey] || US_STATES[stateKey];
      return map && buildMapInfo(stateKey, map);
    default:
      return null;
  }
}

function findMap(name, mapDefs) {
  const found = find(map => name.toLowerCase() === map[0].toLowerCase(), values(mapDefs));

  return found && buildMapInfo(null, found);
}

export default {
  WORLDS,
  CONTINENTS: getList(CONTINENTS),
  COUNTRIES: getList(COUNTRIES),
  CANADA_STATES: getList(CANADA_STATES),
  US_STATES: getList(US_STATES),
  SUPPORTED_COUNTRY_COUNTRIES: ['ca', 'us', 'us-all-territories'],

  getMapInfo,
  searchMapInfoByMapLevel
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.MapCollectionConstants.js